import Finder from './Finder';

export default Finder;
